// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a8989160","239":"4e4955ac","256":"67911ef3","420":"cfef3860","455":"b66dc534"}[chunkId] + ".chunk.js";
};